import { render, staticRenderFns } from "./SupplierOnboardingRepLegIdentityVerification.vue?vue&type=template&id=11f02017&"
import script from "./SupplierOnboardingRepLegIdentityVerification.vue?vue&type=script&lang=js&"
export * from "./SupplierOnboardingRepLegIdentityVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports